import Breadcrumbs from "../../../components/breadcrumbs";
import EventOccasionCreateForm from "./ui/event-occasion-create-form";

export default function EventOccasionCreatePage(){
     return (
            <main className="max-w-3xl ">
              <Breadcrumbs
                breadcrumbs={[
                  { label: "Event Occasions", href: "/admin/event-occasions" },
                  {
                    label: "create",
                    href: `/admin/event-occasions/Create`,
                    active: true,
                  },
                ]}
              />
              
                <EventOccasionCreateForm/>
              
            </main>
          );
        }



